const CALENDAR_MONTHS = [
  "jan",
  "fev",
  "mar",
  "abr",
  "mai",
  "jun",
  "jul",
  "ago",
  "set",
  "out",
  "nov",
  "dez",
];

function calendarDateParts(value) {
  if (!value || value === "undefined") return null;

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return {
      year: value.getUTCFullYear(),
      month: value.getUTCMonth() + 1,
      day: value.getUTCDate(),
    };
  }

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(Date.UTC(year, month - 1, day));

  if (
    parsed.getUTCFullYear() !== year ||
    parsed.getUTCMonth() !== month - 1 ||
    parsed.getUTCDate() !== day
  ) {
    return null;
  }

  return { year, month, day };
}

export function formatShortCalendarDate(value) {
  const parts = calendarDateParts(value);
  if (!parts) return "";
  return parts.day + " " + CALENDAR_MONTHS[parts.month - 1];
}

export function formatCalendarDate(value) {
  const parts = calendarDateParts(value);
  if (!parts) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return pad(parts.day) + "/" + pad(parts.month) + "/" + parts.year;
}
